import type { Firestore } from 'firebase/firestore'
import {
  doc,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import {
  convertDocumentSnapshotToModel,
  modelItemStream,
} from '../../firestore-mobx/stream'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import { SettingsTermsAndConditions } from '../../models/SettingsTermsAndConditions'
import type { FirestoreSettingsTermsAndConditions } from './schema'
import { schema } from './schema'
import { getDocWithError } from '../../firestore-mobx/fetch'

const converter: FirestoreDataConverter<FirestoreSettingsTermsAndConditions> = {
  toFirestore: (data) => data,
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    const data = snapshot.data({ serverTimestamps: 'estimate' })
    return schema.parse(data)
  },
}

const getDocRef = (firestore: Firestore) => {
  return doc(firestore, 'settings', 'terms_and_conditions').withConverter(
    converter
  )
}

export const getSettingsTermsAndConditionsDoc = (
  repository: FirebaseRepository
) => {
  const ref = getDocRef(repository.firestore)

  return modelItemStream(repository, ref, SettingsTermsAndConditions)
}

export const fetchSettingsTermsAndConditions = async (
  repository: FirebaseRepository
) => {
  const ref = getDocRef(repository.firestore)

  const document = await getDocWithError(
    ref,
    'FetchSettingsTermsAndConditionsError'
  )

  // if its not there, don't throw error, just return empty
  if (!document.exists()) {
    const empty = SettingsTermsAndConditions.empty(repository)
    empty.changeLoadingState(false)
    return empty
  }

  return convertDocumentSnapshotToModel(
    repository,
    document,
    SettingsTermsAndConditions
  )
}
